import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });
}

export function formatDateTime(date) {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount || 0);
}

export function getStatusColor(status) {
  const colors = {
    // Request statuses
    requested: 'bg-blue-100 text-blue-800',
    pending_approval: 'bg-yellow-100 text-yellow-800',
    approved: 'bg-green-100 text-green-800',
    rejected: 'bg-red-100 text-red-800',
    ordered: 'bg-purple-100 text-purple-800',
    cancelled: 'bg-gray-100 text-gray-800',
    
    // PO statuses
    draft: 'bg-gray-100 text-gray-800',
    submitted: 'bg-blue-100 text-blue-800',
    confirmed: 'bg-indigo-100 text-indigo-800',
    in_transit: 'bg-cyan-100 text-cyan-800',
    partially_received: 'bg-amber-100 text-amber-800',
    received: 'bg-green-100 text-green-800',
    
    // Part instance statuses
    ready_for_pickup: 'bg-emerald-100 text-emerald-800',
    picked_up: 'bg-teal-100 text-teal-800',
    assigned: 'bg-violet-100 text-violet-800',
    installed: 'bg-green-100 text-green-800',
    returned: 'bg-orange-100 text-orange-800',
    lost: 'bg-red-100 text-red-800',
    damaged: 'bg-rose-100 text-rose-800',
    
    // Urgency
    low: 'bg-slate-100 text-slate-800',
    medium: 'bg-blue-100 text-blue-800',
    high: 'bg-orange-100 text-orange-800',
    critical: 'bg-red-100 text-red-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}

export function getUrgencyBorder(urgency) {
  const borders = {
    low: 'border-l-slate-400',
    medium: 'border-l-blue-500',
    high: 'border-l-orange-500',
    critical: 'border-l-red-500',
  };
  return borders[urgency] || 'border-l-slate-400';
}

export function getRoleLabel(role) {
  const labels = {
    system_admin: 'System Admin',
    purchasing: 'Purchasing',
    approver: 'Approver',
    warehouse: 'Warehouse',
    driver: 'Driver',
    technician: 'Technician',
    dispatcher: 'Dispatcher',
    manager: 'Manager',
    viewer: 'Viewer',
  };
  return labels[role] || role;
}

export function truncate(str, length = 50) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}
